import GLOBAL_KEYS from './_global-keys';
import RETURN_CODES from './_return-code';

export default {
  GLOBAL_KEYS,
  RETURN_CODES,
};



// WEBPACK FOOTER //
// ./src/constants/index.js